import { render, staticRenderFns } from "./SecureVersion.vue?vue&type=template&id=39aa57e3"
import script from "./SecureVersion.vue?vue&type=script&lang=js"
export * from "./SecureVersion.vue?vue&type=script&lang=js"
import style0 from "./SecureVersion.vue?vue&type=style&index=0&id=39aa57e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports